import styles from './MobileEggSelection.module.scss';
import React from 'react';
import { IconButton } from 'components/Button/IconButton';
import { CloseIcon } from 'icons/close';
import cls from 'classnames';
import { MobileDrawer } from 'components/MobileDrawer/MobileDrawer';
import { SelectableEggCardCollection } from 'components/SelectableCard/Variants/SelectableCardEgg';
import { useHatchening } from './state-machine';

export const MobileEggSelection = () => {
  const [state, send] = useHatchening();

  if (!state.context.drawerOpen) {
    return null;
  }

  function onClose() {
    send({ type: 'toggleDrawer' });
  }

  return (
    <MobileDrawer
      onClose={onClose}
      modalId={'mobile-egg-selection'}
      modalHeader={
        <div className={styles.eggSelectionHeaderContainer}>
          <div className={styles.eggSelectionHeader}>
            <h3 className="m-0">Select Eggs</h3>
            <IconButton icon={<CloseIcon />} onClick={onClose} />
          </div>{' '}
          <p className={cls('text-60', styles.eggSelectionText)}>
            Select up to <span className="text-100">5 eggs</span> and hatch
          </p>
          <p className={cls('m-0 text-60', styles.eggSelectionText)}>your Gribble!</p>
        </div>
      }
      modalBody={
        <div className={styles.eggs}>
          {state.context.eggs.map((egg) => {
            return (
              <SelectableEggCardCollection
                card={SelectableEggCardCollection.transformer(egg.item)}
                key={egg.item.id}
                isSelected={egg.selected}
                onClick={(event) => {
                  event.stopPropagation();
                  send({ type: 'toggleEgg', egg: egg.item });
                }}
              />
            );
          })}
        </div>
      }
    />
  );
};
